exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.10@core-js/modules/_wks-ext.js
// module id = 129
// module chunks = 29